"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEPLOYMENT_PLUGINS = void 0;
exports.DEPLOYMENT_PLUGINS = {
    AMAZON: 'AMAZON',
    NGINX: 'NGINX'
};
//# sourceMappingURL=deploymentPlugins.js.map